import React, { useState } from "react";
import { Add, Remove } from "@mui/icons-material";
import ImagePreview from "../imagePreview/ImagePreview";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../../../api/baseUrl";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  addInvestigationImage,
  removeInvestigation,
  removeInvestigationImage,
} from "../../../../../../../../redux/diagnosestate/diagnoseAction";
interface ImageData {
  id: string;
  url: string;
  file: any;
  base64: any;
}

function InvTr({ apiImage, item }: any) {
  const { ID } = useParams();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState<ImageData[]>([]);
  const [open, setopen] = useState(false);
  const [selectedImage, setselectedImage] = useState("");
  const onChangeHandler = async (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const { files } = e.target;
    if (files && files.length > 0) {
      const newImages: ImageData[] = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const base64String = await fileToBase64(file);
        newImages.push({
          id: `image-${formData.length + i}`,
          url: URL.createObjectURL(file),
          file: file,
          base64: base64String,
        });
      }
      setFormData([...formData, ...newImages]);

      const imagesData = newImages.map((imageData) => imageData.base64);
      const response = await baseUrl.patch(
        "/client/treatments/investigation/addInvestigationimage",
        { images: imagesData },
        {
          headers: { treatmentid: ID, investigationid: id },
        }
      );
      console.log(response.data.data);

      // dispatch(addInvestigationImage(id, response.data.data));

      e.target.value = "";
    }
  };

  const removeImage = async (id: string) => {
    const response = await baseUrl.patch(
      "/client/treatments/investigation/removeInvestigationimage",
      {},
      {
        headers: { treatmentid: ID, investigationid: item?._id, imageid: id },
      }
    );
    dispatch(removeInvestigationImage(item?._id, id));
  };
  const fileToBase64 = (file: File) => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result?.toString() ?? "");
      reader.onerror = (error) => reject(error);
    });
  };
  const openImage = (e: string) => {
    setopen(true);
    setselectedImage(e);
  };
  const remove = async (e: any) => {
    try {
      const response = await baseUrl.patch(
        "/client/treatments/investigation/removeInvestigation",
        {},
        {
          headers: { treatmentid: ID, investigationid: e },
        }
      );
      dispatch(removeInvestigation(e));
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit the form.");
    }
  };
  const removeImageById = (idToRemove: string) => {
    const updatedFormData = formData.filter((image) => image.id !== idToRemove);
    setFormData(updatedFormData);
  };
  return (
    <>
      <tr className="hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors">
        <td className="px-4 py-3 text-sm font-medium text-slate-800 dark:text-slate-200">{item?.investigation}</td>
        <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-400">{item?.toothNo || "-"}</td>
        <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-400">{item?.surface || "-"}</td>
        <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-400">{item?.description || "-"}</td>
        <td className="px-4 py-3">
          <div className="flex flex-wrap gap-2 items-center">
            {item?.images?.map((image: any) => (
              <div key={image._id} className="relative group">
                <img
                  src={image.imageUrl}
                  alt={`X-ray ${image._id}`}
                  onClick={() => openImage(image.imageUrl)}
                  className="w-12 h-12 object-cover rounded-lg cursor-pointer hover:opacity-80 transition-opacity border border-slate-200 dark:border-slate-600"
                />
                <button
                  onClick={() => removeImage(image._id)}
                  className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <Remove sx={{ fontSize: 14 }} />
                </button>
              </div>
            ))}
            {formData.map((image: any) => (
              <div key={image.id} className="relative group">
                <img
                  src={image.url}
                  alt={`X-ray ${image.id}`}
                  onClick={() => openImage(image.url)}
                  className="w-12 h-12 object-cover rounded-lg cursor-pointer hover:opacity-80 transition-opacity border border-slate-200 dark:border-slate-600"
                />
                <button
                  onClick={() => removeImageById(image.id)}
                  className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <Remove sx={{ fontSize: 14 }} />
                </button>
              </div>
            ))}
            <label
              htmlFor={`selectimages${formData.length + item?._id}`}
              className="w-12 h-12 border-2 border-dashed border-slate-300 dark:border-slate-600 rounded-lg flex items-center justify-center cursor-pointer hover:border-cyan-500 dark:hover:border-cyan-400 hover:bg-cyan-50 dark:hover:bg-cyan-900/20 transition-colors text-slate-400 dark:text-slate-500 hover:text-cyan-500 dark:hover:text-cyan-400"
            >
              <Add sx={{ fontSize: 20 }} />
            </label>
            <input
              type="file"
              onChange={(e) => onChangeHandler(e, item?._id)}
              id={`selectimages${formData.length + item?._id}`}
              name="xray"
              accept="image/*"
              className="hidden"
              multiple
            />
          </div>
        </td>
        <td className="px-4 py-3">
          <button
            onClick={() => remove(item?._id)}
            className="px-3 py-1 rounded-lg bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 hover:bg-red-200 dark:hover:bg-red-900/50 text-xs font-medium transition-colors"
          >
            Remove
          </button>
        </td>
      </tr>
      {open && (
        <ImagePreview
          data={formData}
          selectedImage={selectedImage}
          setselectedImage={setselectedImage}
          setopen={setopen}
          apiImage={apiImage}
        />
      )}
    </>
  );
}

export default InvTr;
